import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/lib/utils';

interface ExpiresTimerProps {
  formatted: string | null;
  isUrgent?: boolean;
  className?: string;
}

export function ExpiresTimer({ formatted, isUrgent, className }: ExpiresTimerProps) {
  const { t } = useTranslation('invoice-pay');
  if (!formatted) return null;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 text-sm font-normal leading-none text-base-muted-foreground',
        className
      )}
      aria-live="off"
    >
      <Clock className="size-4 shrink-0" aria-hidden />
      <span className="font-normal">{t('expiresIn')}</span>
      <span
        className={cn(
          'font-normal tabular-nums',
          isUrgent ? 'text-fail-foreground' : 'text-success-foreground'
        )}
      >
        {formatted}
      </span>
    </div>
  );
}
